@if (alerts.length > 0) {

  <div class="toast-container" aria-live="polite">

    @for (alert of alerts; track alert.id) {

      <div
        class="app-toast"
        [ngClass]="cssClass(alert)"
        role="alert"
      >

        <!-- Status Icon -->
        <div class="toast-icon">

          @switch (getAlertType(alert)) {

            @case ('success') {
              <i class="fa fa-check"></i>
            }

            @case ('danger') {
              <i class="fa fa-exclamation"></i>
            }

            @case ('warning') {
              <i class="fa fa-exclamation-triangle"></i>
            }

            @default {
              <i class="fa fa-info"></i>
            }

          }

        </div>

        <!-- Message -->
        <div class="toast-message">

          <span class="toast-title">
            {{ getAlertTitle(alert) }}
          </span>

          <p>{{ alert.message }}</p>

        </div>

        <!-- Close -->
        <button
          type="button"
          class="toast-close"
          aria-label="Close notification"
          (click)="removeAlert(alert)"
        >
          <i class="fa fa-times"></i>
        </button>

      </div>

    }

  </div>

}